export interface SlidingBanner {
  id: number;
  title: string;
  body: string;
  color: string;
  sortOrder: number;
  linkUrl: string;
  isActive: boolean;
  speed: number;
  repeat: number;
  createdAt: Date;
  updatedAt: Date;
}

export const slidingBannerFromResponse = (
  responseData: any,
): SlidingBanner => ({
  id: responseData.id,
  title: responseData.title,
  body: responseData.body,
  color: responseData.color,
  sortOrder: responseData.sort_order,
  linkUrl: responseData.link_url,
  isActive: responseData.is_active,
  speed: responseData.speed,
  repeat: responseData.repeat,
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),
});
